import { AuthProvider, AuthOptions } from "./authProviderInterface";
import { setupCognito, getToken, logoutCognito } from "./cognitoAuth";

export class CognitoAuthProvider implements AuthProvider {
    install(Vue: any, options: AuthOptions): void {
        // Cognito setup is handled via interceptors
        this.setupInterceptors();
    }

    async getToken(): Promise<string | undefined> {
        return await getToken();
    }

    logout(): void {
        logoutCognito();
    }

    logoutRedirect(): void {
        // Cognito's hosted-UI logout is already a full-page redirect to its configured logout URI.
        logoutCognito();
    }

    setupInterceptors(): void {
        setupCognito();
    }
}